import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <nav className="bg-white shadow">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        <Link to="/" className="text-xl font-semibold text-primary">
          <img
            src="/images/kstlogo.png" // replace with your logo path
            alt="My Logo"
            className="h-7 w-auto" // adjust height as needed
          />
        </Link>
        <div className="space-x-4 text-gray-600">
          <Link to="/" className="hover:text-primary">
            Home
          </Link>
          <Link to="/about" className="hover:text-primary">
            About
          </Link>
          <Link to="/projects" className="hover:text-primary">
            Projects
          </Link>
          <Link to="/competitions" className="hover:text-primary">
            Competitions
          </Link>
        </div>
      </div>
    </nav>
  );
}
